import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { applyPhoneSchema, splitPhone } from 'framework/utils';
import { useFieldHelper, FieldProps, BaseFieldLayoutType, EmailFieldLayoutType } from 'framework/ui/field';
import { useUiTheme } from 'framework/uiTheme';
import { MobileIcon, EmailIcon } from 'framework/ui/mui-builder';

export interface ContactFieldBaseProps {
  icon: React.ReactNode;
  content: React.ReactNode;
  key?: string | number;
}

export const ContactFieldBase = ({ icon, content, key }: ContactFieldBaseProps) => {
  if (!content) return null;

  return (
    <Box key={key} display="flex" alignItems="center" gap={1}>
      {icon}
      {content}
    </Box>
  );
};

export const ContactPhoneField = (props: FieldProps) => {
  const { getValue } = useFieldHelper(props);
  const { titleAccess } = props;
  const value = splitPhone(getValue());
  const phone = value && applyPhoneSchema(value.phone);
  const extension = value && value.extension;

  const { BaseFieldLayout } = useUiTheme<BaseFieldLayoutType>();

  if (!phone) return null;

  const content = (
    <Box display="flex" alignItems="center" gap={0.5}>
      <Link href={`tel:${phone}`} color="primary" underline="none" variant="body1">
        {phone}
      </Link>

      {extension && (
        <Typography variant="body1" className="extension">
          {`ext ${extension}`}
        </Typography>
      )}
    </Box>
  );

  const icon = <MobileIcon sx={{ width: '20px', height: '20px' }} titleAccess={titleAccess} />;

  return <BaseFieldLayout value={<ContactFieldBase key={phone} icon={icon} content={content} />} label="" />;
};

export const ContactEmailField = (props: FieldProps) => {
  const { getValue } = useFieldHelper(props);
  const { EmailFieldLayout } = useUiTheme<EmailFieldLayoutType>();
  const { className, titleAccess } = props;
  const email = getValue();

  if (!email) return null;

  const icon = <EmailIcon sx={{ width: '20px', height: '20px' }} titleAccess={titleAccess} />;
  const content = <EmailFieldLayout className={className} value={email} />;

  return <ContactFieldBase key={email} icon={icon} content={content} />;
};
